// src/telehealth/chatHelpers.js
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase";

/**
 * Ensure there is a conversation between this doctor & patient
 * for a specific appointment. Returns conversationId.
 */
export async function ensureConversation({
  appointmentId,
  doctorId,
  patientId,
  doctorName,
  patientName,
  appointmentStatus,
  serviceName,
}) {
  const conversationId = `${appointmentId}_${doctorId}_${patientId}`;
  const convRef = doc(db, "conversations", conversationId);
  const snap = await getDoc(convRef);

  const closed =
    (appointmentStatus || "").toLowerCase() === "completed" ||
    (appointmentStatus || "").toLowerCase() === "cancelled";

  const base = {
    doctorId,
    patientId,
    appointmentId,
    doctorName: doctorName || null,
    patientName: patientName || null,
    appointmentStatus: appointmentStatus || null,
    serviceName: serviceName || null,
    isClosed: closed,
  };

  if (!snap.exists()) {
    await setDoc(convRef, {
      ...base,
      createdAt: serverTimestamp(),
      lastMessageAt: serverTimestamp(),
      lastMessagePreview: "",
      status: "active",
    });
  } else {
    // keep metadata fresh (e.g. appointment moved to completed)
    await setDoc(
      convRef,
      {
        ...base,
        // don’t override createdAt/lastMessageAt here
      },
      { merge: true }
    );
  }

  return conversationId;
}
